/** I listini dei fornitori nella console (atlante v2, cap. 435, 28/10/2026). Gemello di `en.ts`. */
export default {
  pagina: {
    titolo: 'Listini dei fornitori',
    descrizione: 'Il listino di ogni fornitore, controllato ogni mattina dalla sua fonte. Una versione nuova resta in bozza finché non la pubblichi; i preventivi non cambiano mai da soli: ogni amministratore sceglie da quando usarla.',
    ricarica: 'Ricarica',
    caricamento: 'Leggo i listini…',
    errore: 'I listini non si sono caricati: {{motivo}}',
    nessuno: 'Nessun fornitore ha ancora un listino a versioni. Si crea con scripts/listini/crea-versione-1-listino-fornitore.cjs.',
  },
  fornitore: {
    in_vigore: 'In vigore la versione {{numero}}',
    del_listino: 'listino del {{data}}',
    controlla: 'Controlla adesso',
    controllo_in_corso: 'Controllo la fonte…',
    fonte: 'Fonte',
    fonte_drive: '«{{file}}» nella cartella pubblica di Google Drive',
    apri_cartella: 'Apri la cartella',
    senza_fonte: 'Nessuna fonte: le versioni si preparano a mano con lo script.',
    ultimo_controllo: 'Ultimo controllo',
    mai_controllato: 'mai',
    problema: 'Problema all’ultimo controllo: {{motivo}}',
    file_non_trovato: 'il file non è più nella cartella (rinominato o tolto dal fornitore)',
  },
  esiti_controllo: {
    invariato: 'Il file è lo stesso dell’ultimo controllo: niente di nuovo.',
    bozza: 'Il listino è cambiato: è pronta la bozza della versione {{numero}}.',
    file_non_trovato: 'Nella cartella non c’è più il file del listino.',
    senza_fonte: 'Questo fornitore non ha una fonte da controllare.',
    errore: 'Il controllo non è riuscito: {{motivo}}',
  },
  bozza: {
    titolo: 'Bozza della versione {{numero}}',
    preparata: 'Preparata il {{quando}} dal listino del {{data}}',
    preparata_senza_data: 'Preparata il {{quando}}',
    apri_pdf: 'Apri il PDF del fornitore',
    nessuna: 'Nessuna bozza da pubblicare.',
    sezioni: {
      cambiano: 'Cambiano prezzo',
      escono: 'Escono dal listino',
      da_verificare: 'Da verificare',
    },
    colonne: {
      codice: 'Codice',
      prima: 'Prima',
      dopo: 'Dopo',
      differenza: 'Differenza',
      motivo: 'Perché',
      nel_listino: 'Nel listino nuovo',
    },
    vuota: {
      cambiano: 'Nessun prezzo cambia.',
      escono: 'Nessun prodotto esce dal listino.',
      da_verificare: 'Niente da verificare.',
    },
    spiega_escono: 'Restano col prezzo di prima e l’avviso «non più nel listino del fornitore», finché il fornitore non conferma.',
    spiega_verifica: 'Il prezzo non si cambia: resta quello di prima finché il fornitore non chiarisce.',
    motivi: {
      codice: 'forse ha cambiato codice',
      piu_prezzi: 'più prezzi per lo stesso codice',
      soglia: 'cambia più della soglia',
    },
  },
  conteggi: {
    salgono_one: '{{count}} sale',
    salgono_other: '{{count}} salgono',
    scendono_one: '{{count}} scende',
    scendono_other: '{{count}} scendono',
    invariati_one: '{{count}} invariato',
    invariati_other: '{{count}} invariati',
    escono_one: '{{count}} esce',
    escono_other: '{{count}} escono',
    da_verificare_one: '{{count}} da verificare',
    da_verificare_other: '{{count}} da verificare',
    nuovi_one: '{{count}} prezzo di partenza',
    nuovi_other: '{{count}} prezzi di partenza',
  },
  pubblica: {
    avvisa: 'Avvisa gli amministratori delle aziende clienti',
    avvisa_spiega: 'Ricevono l’avviso nella campanella e per email, e scelgono da quando usare i prezzi nuovi.',
    bottone: 'Pubblica la versione {{numero}}',
    conferma_titolo: 'Pubblicare la versione {{numero}}?',
    conferma_prezzi_one: '{{count}} prodotto prende il prezzo nuovo nel catalogo del fornitore.',
    conferma_prezzi_other: '{{count}} prodotti prendono il prezzo nuovo nel catalogo del fornitore.',
    conferma_escono_one: '{{count}} prodotto riceve l’avviso «non più nel listino».',
    conferma_escono_other: '{{count}} prodotti ricevono l’avviso «non più nel listino».',
    conferma_preventivi: 'Nessun preventivo cambia: ogni amministratore sceglie da quando usare la versione e su quali preventivi.',
    conferma_avvisi_si: 'Gli amministratori delle aziende clienti ricevono l’avviso, anche per email.',
    conferma_avvisi_no: 'Nessun avviso e nessuna email: la versione si vede nella pagina «Listino del fornitore» di ogni azienda.',
    annulla: 'Annulla',
    in_corso: 'Pubblico…',
    fatto: 'Versione {{numero}} pubblicata: {{prezzi}} prodotti col prezzo nuovo, {{escono}} fuori listino.',
    errore: 'La versione non è stata pubblicata: {{motivo}}',
  },
  storia: {
    titolo: 'Versioni pubblicate',
    versione: 'Versione {{numero}}',
    origine_catalogo: 'i prezzi del catalogo',
    pubblicata: 'pubblicata il {{quando}}',
    con_avvisi: 'con avvisi',
    senza_avvisi: 'senza avvisi',
  },
} as const;
